import Keycloak from "keycloak-js";
import axios from 'axios';

const keycloakConfig = {
  "url": process.env.REACT_APP_KEYCLOAK,
  "realm": "PUV-FRONT",
  "clientId": "puv",
  "token":""
};
const keycloak = new Keycloak(keycloakConfig);

const instanceKeycloak = axios.create({
  baseURL: process.env.REACT_APP_KEYCLOAK
});

instanceKeycloak.interceptors.request.use(async (config) => {
  const token = keycloak.token;

  config.headers['Authorization'] = `Bearer ${token}`;

  return config;
});

export { keycloak, instanceKeycloak };
